@if (current.length > 0) {
<div class="error">
  @for (msg of current; track msg) {
  <div>{{ msg }}</div>
  }
</div>
}
